/* ==========================================================================
   Yumeka — tiroir panier
   --------------------------------------------------------------------------
   Ce fichier ne calcule aucun montant. Chaque action poste au panier en
   demandant au passage le rendu de la section `cart-drawer`, et remplace le
   contenu du tiroir par ce que le serveur renvoie. Les prix affichés sortent
   donc toujours du filtre `money` de Shopify, avec la devise et le format
   réels de la boutique.

   Sans `fetch`, aucun écouteur n'est posé : le lien du panier de l'en-tête
   reste un lien vers /cart, qui fonctionne seul.
   ========================================================================== */
(function () {
  'use strict';

  if (!window.fetch || !window.Promise) return;

  var SECTION = 'cart-drawer';
  var $ = function (s, r) { return (r || document).querySelector(s); };
  var $$ = function (s, r) { return Array.prototype.slice.call((r || document).querySelectorAll(s)); };

  var root = $('[data-cart-drawer]');
  if (!root) return;

  var panel = $('[data-cart-panel]', root);
  var lastFocus = null;
  var lastAction = null;   // rejoué par « Réessayer »

  /* Verrou de l echange de coloris, PARTAGE entre les deux scripts.

     Changer la couleur d un cadeau se fait en deux temps : retirer la ligne,
     puis ajouter la variante voulue. Entre les deux, le panier n a plus de
     cadeau, et personne ne doit juger cet etat.

     Il a d abord ete ecrit comme une variable de fichier. Ca ne suffit pas :
     sur /cart, cart-page.js ET cart-drawer.js tournent tous les deux. La page
     levait son verrou, le tiroir gardait le sien a zero, son observateur le
     reveillait au retrait, et son addGift() rajoutait le coloris d origine.
     Trace relevee sur la boutique : change.js du Blanc, add.js du Gris, puis
     add.js du Blanc emis par post() de cart-drawer.js. Deux taies au panier.

     Le compteur vit donc sur window, seul terrain que les deux partagent.
     Un compteur et non un booleen : deux menus changes coup sur coup ne
     doivent pas voir le premier revenu lever le verrou du second. */
  function verrouEchange(delta) {
    var v = (window.__ykEchangeCadeau || 0) + (delta || 0);
    window.__ykEchangeCadeau = v > 0 ? v : 0;
    return window.__ykEchangeCadeau;
  }

  /* ---------- ouverture / fermeture ------------------------------------- */

  function open() {
    if (root.classList.contains('is-open')) return;
    lastFocus = document.activeElement;
    root.classList.add('is-open');
    root.setAttribute('aria-hidden', 'false');
    document.body.style.overflow = 'hidden';
    var first = $('[data-cart-close]', panel);
    if (first) first.focus();
    /* Ce que le serveur a rendu peut dater : l observateur pose plus bas
       prend le relais des qu une requete modifie le panier. */
    resynchroniser();
  }

  function close() {
    root.classList.remove('is-open');
    root.setAttribute('aria-hidden', 'true');
    document.body.style.overflow = '';
    if (lastFocus && lastFocus.focus) lastFocus.focus();
  }

  /* Le lien du panier reste un vrai lien : on n'intercepte que quand tout va
     bien, et jamais un clic modifié — nouvel onglet, bouton du milieu, etc.

     `e.button` n'est pas fiable partout sur un clic issu d'un appui tactile :
     certains moteurs le laissent indéfini. Exiger `=== 0` faisait donc échouer
     l'interception sur ces appareils, et le lien naviguait vers /cart au lieu
     d'ouvrir le tiroir. On n'écarte plus que ce qui est explicitement un autre
     bouton que le principal. */
  function clicModifie(e) {
    return e.metaKey || e.ctrlKey || e.shiftKey || e.altKey || (e.button != null && e.button !== 0);
  }

  function interceptePanier(e) {
    if (clicModifie(e)) return;
    e.preventDefault();
    open();
  }

  document.addEventListener('click', function (e) {
    var cible = e.target;
    var link = cible.closest && cible.closest('a[href$="/cart"], a[href$="/cart/"]');
    if (link) { interceptePanier(e); return; }
    var closer = cible.closest && cible.closest('[data-cart-close]');
    if (closer && root.contains(closer)) close();
  });

  /* Ceinture et bretelles : en plus de la délégation, on écoute directement
     sur chaque lien présent au chargement. La délégation dépend du fait que
     `closest` remonte depuis la cible réelle du doigt — sur l'icône du panier,
     c'est un `<path>` à l'intérieur d'un `<svg>`. Écouter aussi sur le lien
     lui-même supprime ce maillon. */
  $$('a[href$="/cart"], a[href$="/cart/"]').forEach(function (a) {
    a.addEventListener('click', interceptePanier);
  });

  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && root.classList.contains('is-open')) close();
  });

  /* Le tiroir s'ouvre aussi sans clic : la page panier en a besoin sur
     téléphone. Passer par un clic simulé sur le lien de l'en-tête marchait sur
     un navigateur de bureau et pas toujours ailleurs — cela dépendait d'un
     sélecteur, de l'ordre des écouteurs et de l'annulation d'un événement
     synthétique. Une fonction appelée directement ne dépend de rien de tout
     cela. L'événement prévient ceux qui chargent après nous. */
  window.YumekoCart = {
    open: open,
    close: close,
    estOuvert: function () { return root.classList.contains('is-open'); }
  };
  document.dispatchEvent(new CustomEvent('yumeko:cart-ready'));

  /* Piège de focus : le tiroir est `aria-modal`, la tabulation ne doit pas en
     sortir tant qu'il est ouvert. */
  panel.addEventListener('keydown', function (e) {
    if (e.key !== 'Tab') return;
    var f = $$('a[href], button:not([disabled]), select, input, [tabindex]:not([tabindex="-1"])', panel)
      .filter(function (el) { return el.offsetParent !== null; });
    if (!f.length) return;
    var first = f[0], last = f[f.length - 1];
    if (e.shiftKey && document.activeElement === first) { e.preventDefault(); last.focus(); }
    else if (!e.shiftKey && document.activeElement === last) { e.preventDefault(); first.focus(); }
  });

  /* ---------- erreur ------------------------------------------------------ */

  function showError(msg) {
    var box = $('[data-cart-error]', root);
    if (!box) { window.alert(msg); return; }
    $('[data-cart-error-text]', box).textContent = msg;
    $('[data-cart-retry]', box).hidden = !lastAction;
    box.hidden = false;
  }
  function clearError() {
    var box = $('[data-cart-error]', root);
    if (box) box.hidden = true;
  }

  /* ---------- rendu ------------------------------------------------------- */

  /* La position du focus est rendue par son adresse — la ligne concernée et le
     rôle du contrôle — et non par une référence au nœud : celui-ci disparaît
     au remplacement. Sans cela, trois pressions sur « + » renverraient le
     focus au corps du document dès la première. */
  function focusAddress() {
    var el = document.activeElement;
    if (!el || !panel.contains(el)) return null;
    var line = el.closest('[data-key]');
    if (el.hasAttribute('data-cart-step')) {
      return { key: line && line.dataset.key, sel: '[data-cart-step="' + el.getAttribute('data-cart-step') + '"]' };
    }
    if (el.hasAttribute('data-cart-remove')) return { key: line && line.dataset.key, sel: '[data-cart-remove]' };
    if (el.hasAttribute('data-cart-bundle-remove')) return { key: line && line.dataset.key, sel: '[data-cart-bundle-remove]' };
    if (el.hasAttribute('data-cart-add')) return { key: null, sel: '[data-cart-add]' };
    return null;
  }

  function restoreFocus(addr) {
    if (!addr) return;
    var scope = addr.key ? $('[data-key="' + addr.key + '"]', root) : root;
    var target = scope && $(addr.sel, scope);
    /* La ligne peut avoir disparu (dernier exemplaire retiré) ou le bouton
       être devenu inactif : on se rabat sur la fermeture, jamais sur rien. */
    if (!target || target.disabled) target = $('[data-cart-close]', panel);
    if (target) target.focus();
  }

  /* ---------- décompte du bandeau de stock -------------------------------
     La durée vient du serveur ; le temps écoulé est mesuré avec
     `performance.now()`, qui compte des millisecondes et non une heure : une
     horloge locale déréglée n'a donc aucun effet sur le décompte. À zéro le
     bandeau disparaît, il ne repart pas de lui-même.

     À savoir, et c'est inhérent au procédé : aucun stock n'est immobilisé
     pendant ce décompte, et il repart à chaque chargement de page. */
  var reserveId = null;

  function initReserve() {
    if (reserveId) { clearInterval(reserveId); reserveId = null; }
    var band = $('[data-cart-reserve]', root);
    if (!band) return;
    var total = parseInt(band.getAttribute('data-cart-reserve'), 10);
    if (!(total > 0)) return;
    var mEl = $('[data-m]', band), sEl = $('[data-s]', band);
    if (!mEl || !sEl) return;

    /* Deux horloges, selon que le décompte doit survivre au rechargement.

       Sans persistance : performance.now(), qui compte des millisecondes
       écoulées et non une heure. Une horloge locale déréglée n'a aucun effet,
       mais le décompte repart à chaque chargement de page.

       Avec persistance : une échéance absolue rangée dans le sessionStorage de
       l'onglet, et Date.now() pour la viser. Le décompte devient continu d'une
       page à l'autre — c'est ce qui est demandé, et c'est aussi ce qui le rend
       cohérent : un minuteur qui redémarre sous les yeux de la cliente dit de
       lui-même qu'il ne compte rien.

       Ce que la persistance ne change pas : aucun stock n'est immobilisé
       pendant ce décompte, l'échéance est fabriquée par le navigateur et non
       par le serveur, et un nouvel onglet repart à zéro. */
    var keep = band.getAttribute('data-cart-reserve-keep') === '1';
    var anchor = performance.now();
    var due = 0;

    if (keep) {
      var KEY = 'ycd-reserve-due';
      try {
        var saved = parseInt(sessionStorage.getItem(KEY), 10);
        /* Une échéance déjà dépassée, ou plus lointaine que la durée réglée,
           est écartée : la seconde vient d'un réglage abaissé depuis, et la
           garder ferait tourner un décompte plus long que celui annoncé. */
        if (saved > Date.now() && saved - Date.now() <= total * 1000) due = saved;
        if (!due) {
          due = Date.now() + total * 1000;
          sessionStorage.setItem(KEY, String(due));
        }
      } catch (e) {
        /* Navigation privée, stockage refusé : on retombe sur le décompte
           non persistant plutôt que de ne rien afficher. */
        keep = false;
      }
    }

    function tick() {
      var left = keep
        ? Math.max(0, Math.round((due - Date.now()) / 1000))
        : Math.max(0, Math.round(total - (performance.now() - anchor) / 1000));
      if (left <= 0) {
        clearInterval(reserveId);
        reserveId = null;
        band.remove();
        return;
      }
      /* Minutes et secondes sur deux chiffres, comme la référence : « 09:19 »
         et non « 9:19 ». Avec les segments à largeur fixe du CSS, le bandeau ne
         bouge d'aucun pixel en tournant. */
      mEl.textContent = ('0' + Math.floor(left / 60)).slice(-2);
      sEl.textContent = ('0' + (left % 60)).slice(-2);
    }
    tick();
    reserveId = setInterval(tick, 1000);
  }

  function render(html) {
    var addr = focusAddress();
    var doc = new DOMParser().parseFromString(html, 'text/html');
    var fresh = doc.querySelector('[data-cart-inner]');
    var current = $('[data-cart-inner]', panel);
    if (!fresh || !current) return;
    /* La zone defilante est remplacee d'un bloc : sans cela le tiroir remonte
       en tete a chaque mise a jour, et la ligne qu'on vient de modifier sort de
       l'ecran. On relit la position avant, on la repose apres. */
    var ancienneZone = $('[data-cart-scroll]', panel);
    var position = ancienneZone ? ancienneZone.scrollTop : 0;
    current.replaceWith(fresh);
    var nouvelleZone = $('[data-cart-scroll]', panel);
    if (nouvelleZone && position) nouvelleZone.scrollTop = position;
    restoreFocus(addr);
    initReserve();

    $$('[data-cart-count]').forEach(function (n) {
      n.textContent = fresh.dataset.count;
      n.hidden = fresh.dataset.count === '0';
    });

    purgeGift();
    addGift();
    rafraichirPage();
  }

  /* Retrait des cadeaux qui n'ont rien à faire là.

     Le gabarit marque les lignes offertes dont le produit déclencheur n'est pas
     au panier — un produit à 0 € ajouté seul, par une adresse directe ou un
     panier restauré. On les retire une par une : chaque retrait provoque un
     nouveau rendu, qui rejoue ce contrôle sur le panier recalculé par le
     serveur. Deux cadeaux illégitimes partent donc en deux passes, sans qu'on
     ait à deviner l'état intermédiaire.

     Le compteur borne la boucle. Si le serveur renvoyait indéfiniment une ligne
     qu'on vient de retirer, mieux vaut s'arrêter et laisser le panier tel quel
     que marteler l'API : un panier figé se voit, une boucle ne se voit pas. */
  var purgeTries = 0;

  function purgeGift() {
    if (verrouEchange(0) > 0) return;
    var inner = $('[data-cart-inner]', panel);
    if (!inner) return;
    var raw = inner.getAttribute('data-cart-gift-purge') || '';
    var keys = raw.split(',').filter(Boolean);
    if (!keys.length) { purgeTries = 0; return; }
    if (++purgeTries > 6) return;
    post('/cart/change.js', { id: keys[0], quantity: 0 });
  }

  /* Ajout du cadeau que le panier a merite.

     Le gabarit ne pose l attribut que si le cadeau manque ET que le panier y a
     droit : il n y a donc rien a decider ici. Une fois ajoute, le produit est
     dans le panier, le rendu suivant ne pose plus l attribut, et la boucle
     s arrete d elle-meme.

     Le compteur est une securite, pas une regle : si le serveur refusait
     l ajout — rupture de stock sur le cadeau, par exemple — on cesserait de
     redemander plutot que de marteler l API. */
  var addTries = 0;

  function addGift() {
    /* Le cadeau est absent parce qu on vient de le retirer pour le remplacer.
       Le rajouter ici, c est en livrer deux. */
    if (verrouEchange(0) > 0) return;
    var inner = $('[data-cart-inner]', panel);
    if (!inner) return;
    var id = inner.getAttribute('data-cart-gift-add');
    if (!id) { addTries = 0; return; }
    if (++addTries > 3) return;
    post('/cart/add.js', { items: [{ id: Number(id), quantity: 1 }] });
  }

  function post(url, body, busy) {
    lastAction = function () { post(url, body, busy); };
    clearError();
    if (busy) busy.classList.add('is-busy');
    body.sections = SECTION;
    body.sections_url = window.location.pathname;

    return fetch(url, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify(body)
    })
      .then(function (r) {
        /* La reponse est lue en TEXTE avant d etre analysee.

           r.json() sur une page HTML jette « Unexpected token '<' … is not
           valid JSON », et ce message partait tel quel dans le bandeau du
           tiroir : la cliente lisait une erreur de parseur, et nous
           n apprenions rien de la panne.

           Du HTML sur /cart/*.js veut dire que la requete n a pas atteint
           l API du panier : page de mot de passe, session expiree, controle
           anti-robot, ou le proxy de `shopify theme dev`. Aucun de ces cas
           ne se repare en reessayant le meme appel — le message le dit, et
           donne le code renvoye pour qu on sache lequel c est. */
        return r.text().then(function (t) {
          var b;
          try { b = JSON.parse(t); }
          catch (e) {
            throw new Error('Le panier n’a pas répondu (' + r.status + '). Rechargez la page.');
          }
          if (!r.ok) throw new Error(b.description || b.message || b.errors || 'Mise à jour impossible.');
          return b;
        });
      })
      .then(function (data) {
        lastAction = null;
        /* Le panier a bien ete modifie ; c est le rendu de la section qui
           manque. Recharger vaut mieux que laisser l ecran afficher un etat
           qui n est plus vrai. */
        if (!data.sections || !data.sections[SECTION]) { window.location.reload(); return; }
        render(data.sections[SECTION]);
      })
      .catch(function (err) {
        if (busy) busy.classList.remove('is-busy');
        showError(err.message === 'Failed to fetch'
          ? 'Connexion perdue. Le panier n’a pas été modifié.'
          : err.message);
      });
  }

  /* ---------- actions ----------------------------------------------------- */

  /* Changement de coloris sur une ligne offerte.

     L'API du panier ne sait pas remplacer une variante : /cart/change.js ne
     touche qu'a la quantite. On retire donc la ligne, puis on ajoute la
     variante choisie dans la meme quantite. Deux appels, dans cet ordre --
     ajouter d'abord ferait cohabiter deux cadeaux le temps d'un rendu, et le
     garde-fou anti-abus en retirerait un au hasard.

     La delegation porte sur le panneau et non sur le <select> : le tiroir est
     entierement re-rendu a chaque mise a jour, un ecouteur pose sur l'element
     serait perdu au premier changement. */
  panel.addEventListener('change', function (e) {
    var sel = e.target.closest ? e.target.closest('[data-gift-variant]') : null;
    if (!sel) return;
    var cle = sel.getAttribute('data-key');
    var qte = parseInt(sel.getAttribute('data-qty'), 10) || 1;
    var id = parseInt(sel.value, 10);
    if (!cle || !id) return;

    // Le <select> porte lui aussi data-key : closest('[data-key]') le
    // renvoyait lui-meme au lieu de la ligne. On vise la ligne par sa classe.
    var ligne = sel.closest('.ykb, .ycd__item');
    if (ligne) ligne.classList.add('is-busy');

    /* Le changement s'affiche tout de suite, le reseau suit.
       ------------------------------------------------------------------
       Mesure sur la boutique : le retrait coute 387 ms, l'ajout 565 ms, soit
       952 ms d'attente les yeux sur un menu fige. Le rendu de la section, lui,
       ne coute que 34 ms -- ce n'est pas lui qu'il fallait optimiser.

       On met donc a jour localement ce qui change VRAIMENT, c'est-a-dire le
       nom du coloris et la vignette, puis on laisse les deux appels partir
       derriere. Aucun montant n'est calcule ici : la ligne vaut 0 EUR avant
       comme apres, le total ne bouge pas. C'est la seule raison pour laquelle
       cet affichage anticipe est acceptable -- sur un prix, il ne le serait
       pas.

       Aucun re-rendu au retour : on se contente de reporter la nouvelle cle de
       ligne, sans quoi le retrait suivant viserait une ligne disparue. */
    clearError();
    var opt = sel.options[sel.selectedIndex];
    var ancienneCle = cle;
    /* Index d'avant le changement, pour pouvoir revenir en arriere. Au
       premier passage il vient de l'option marquee selected par le serveur ;
       ensuite c'est le dernier changement reussi qui fait foi. */
    var ancienIndex = (typeof sel.__ancienIndex === 'number')
      ? sel.__ancienIndex
      : Array.prototype.slice.call(sel.options).findIndex(function (o) { return o.defaultSelected; });

    var etiquette = ligne ? ligne.querySelector('.ycd__variant') : null;
    var vignette = ligne ? ligne.querySelector('.ykb__thumb, .ycd__thumb') : null;
    var pastille = ligne ? ligne.querySelector('[data-gift-swatch]') : null;
    var titreAvant = etiquette ? etiquette.textContent : null;
    var imgAvant = vignette && vignette.tagName === 'IMG' ? vignette.src : null;
    var teinteAvant = pastille ? pastille.style.getPropertyValue('--sw') : null;

    if (etiquette && opt.getAttribute('data-titre')) {
      etiquette.textContent = etiquette.textContent.replace(/:\s*.*$/, ': ' + opt.getAttribute('data-titre'));
    }
    if (vignette && vignette.tagName === 'IMG' && opt.getAttribute('data-img')) {
      vignette.src = opt.getAttribute('data-img');
    }
    /* La pastille suit le menu tout de suite, comme le nom et la vignette :
       elle indique le coloris choisi, pas celui que le panier a confirme. Le
       retour arriere ci-dessous la remet en place si l'appel echoue. */
    if (pastille && opt.getAttribute('data-swatch')) {
      pastille.style.setProperty('--sw', opt.getAttribute('data-swatch'));
    }

    /* Si l echange n aboutit ni en succes ni en erreur -- onglet endormi,
       reseau muet -- le verrou resterait leve et le panier cesserait de se
       resynchroniser. Il tombe seul au bout de dix secondes. */
    verrouEchange(1);
    var verrouRelache = false;
    var finEchange = function () { if (verrouRelache) return; verrouRelache = true; verrouEchange(-1); };
    setTimeout(finEchange, 10000);

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: ancienneCle, quantity: 0 })
    })
      .then(function (r) {
        if (!r.ok) throw new Error('Changement impossible.');
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
          body: JSON.stringify({ items: [{ id: id, quantity: qte }] })
        });
      })
      .then(function (r) {
        if (!r.ok) throw new Error('Ajout impossible.');
        return r.json();
      })
      .then(function (data) {
        var ajoute = data && data.items && data.items[0];
        if (ajoute && ajoute.key) {
          if (ligne) ligne.setAttribute('data-key', ajoute.key);
          sel.setAttribute('data-key', ajoute.key);
          $$('[data-cart-bundle-remove]', root).forEach(function (button) {
            var keys = button.getAttribute('data-cart-bundle-keys') || '';
            button.setAttribute('data-cart-bundle-keys', keys.replace(ancienneCle, ajoute.key));
          });
        }
        sel.__ancienIndex = sel.selectedIndex;
        if (ligne) ligne.classList.remove('is-busy');
        /* Le panier est complet : le verrou tombe, et la resynchronisation
           declenchee par cet ajout verra un panier coherent. */
        finEchange();
      })
      .catch(function () {
        /* Retour arriere complet : le menu, le nom et la vignette reprennent
           leur etat d'avant. Mieux vaut un changement refuse qu'un panier qui
           affiche un coloris qu'il ne contient pas. */
        if (etiquette && titreAvant !== null) etiquette.textContent = titreAvant;
        if (vignette && imgAvant) vignette.src = imgAvant;
        if (pastille && teinteAvant !== null) pastille.style.setProperty('--sw', teinteAvant);
        if (ancienIndex >= 0) sel.selectedIndex = ancienIndex;
        if (ligne) ligne.classList.remove('is-busy');
        finEchange();
        showError('Ce coloris n’a pas pu être appliqué.');
      });
  });

  panel.addEventListener('click', function (e) {
    var t = e.target;

    /* Un pack BundleX reste composé de plusieurs lignes Shopify (payées et
       offertes), même s'il est présenté comme une seule carte. Une seule
       corbeille les retire donc ensemble avec leurs clés de ligne réelles. */
    var bundleRemove = t.closest('[data-cart-bundle-remove]');
    if (bundleRemove) {
      var bundleRow = bundleRemove.closest('[data-key]');
      /* Les lignes du pack sont retrouvees MAINTENANT, par leur produit.

         Les cles rendues par Liquid perimaient : changer le coloris du cadeau
         remplace la ligne et lui donne une nouvelle cle. update.js repondait
         alors 200 sans rien retirer, et la corbeille paraissait morte.
         Constate sur la boutique : deux cles d oreiller valides, une cle de
         taie perimee, et le pack restait entier au panier.

         Les identifiants de produit, eux, survivent a tout echange. Les cles
         du gabarit ne servent plus que de repli si /cart.js ne repond pas. */
      var repli = (bundleRemove.getAttribute('data-cart-bundle-keys') || '').split(',').filter(Boolean);
      var produits = (bundleRemove.getAttribute('data-cart-bundle-products') || '').split(',').filter(Boolean);
      var partir = function (updates) {
        if (!Object.keys(updates).length) { bundleRow.classList.remove('is-busy'); return; }
        post('/cart/update.js', { updates: updates }, bundleRow);
      };
      var parRepli = function () { var u = {}; repli.forEach(function (k) { u[k] = 0; }); return u; };
      bundleRow.classList.add('is-busy');
      fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (panier) {
          var u = {};
          if (panier && produits.length) {
            panier.items.forEach(function (it) {
              if (produits.indexOf(String(it.product_id)) !== -1) u[it.key] = 0;
            });
          }
          partir(Object.keys(u).length ? u : parRepli());
        })
        .catch(function () { partir(parRepli()); });
      return;
    }

    var step = t.closest('[data-cart-step]');
    if (step) {
      var line = step.closest('[data-key]');
      var now = parseInt($('[data-cart-count-line]', line).textContent, 10) || 0;
      var next = now + parseInt(step.getAttribute('data-cart-step'), 10);
      line.classList.add('is-busy');
      post('/cart/change.js', { id: line.dataset.key, quantity: Math.max(next, 0) }, line);
      return;
    }

    /* Vider le panier : une confirmation, parce que le geste ne se defait pas.
       /cart/clear.js rend la section comme les autres appels ; a defaut,
       post() recharge la page, ce qui montre aussi un panier vide. */
    var vider = t.closest('[data-cart-clear]');
    if (vider) {
      if (!window.confirm('Vider le panier ?')) return;
      post('/cart/clear.js', {}, vider);
      return;
    }

    var rm = t.closest('[data-cart-remove]');
    if (rm) {
      var row = rm.closest('[data-key]');
      row.classList.add('is-busy');
      post('/cart/change.js', { id: row.dataset.key, quantity: 0 }, row);
      return;
    }

    /* Recommandation du panier vide : la déclinaison vient de la liste
       déroulante voisine, jamais d'un identifiant figé dans le bouton — sinon
       changer de coloris ajouterait quand même le premier. */
    var add = t.closest('[data-cart-add]');
    if (add) {
      var sel = $('[data-cart-variant]', add.closest('.ycd__reco-card'));
      if (!sel || !sel.value) return;
      post('/cart/add.js', { items: [{ id: Number(sel.value), quantity: 1 }] }, add);
      return;
    }

    /* Protection d'expédition. L'interrupteur ne fait rien d'autre qu'ajouter
       ou retirer un vrai produit du panier : ce que le client voit à l'écran
       est exactement ce qui part à la caisse. La position ne se mémorise pas
       en JavaScript — elle se relit du panier au rendu suivant, sinon un
       interrupteur pourrait rester allumé sur un panier qui ne contient plus
       la ligne. */
    var prot = t.closest('[data-cart-protection]');
    if (prot) {
      var on = prot.classList.contains('is-on');
      prot.classList.add('is-busy');
      if (on) {
        post('/cart/change.js', { id: prot.getAttribute('data-cart-protection-key'), quantity: 0 }, prot);
      } else {
        post('/cart/add.js', { items: [{ id: Number(prot.getAttribute('data-cart-protection')), quantity: 1 }] }, prot);
      }
      return;
    }

    var retry = t.closest('[data-cart-retry]');
    if (retry && lastAction) { var again = lastAction; lastAction = null; again(); }
  });

  initReserve();
  /* Au chargement de la page, et pas seulement apres une modification.

     purgeGift et addGift n etaient appeles que depuis render(), qui ne tourne
     qu au retour d un post. Le gabarit demandait donc bien l ajout des la
     premiere page — l attribut etait la — mais personne ne le lisait tant que
     la cliente ne touchait pas a une quantite. Vu sur la boutique : panier de
     deux oreillers, data-cart-gift-add rendu, et aucun cadeau ajoute.

     L instruction du serveur doit etre executee des qu elle est rendue, pas
     seulement quand quelque chose d autre la reveille. */
  /* Un seul script amorce, jamais deux.

     Sur la page panier, cart-page.js tourne EN PLUS de celui-ci : les deux
     lisaient l instruction du serveur et postaient l ajout en meme temps. Deux
     appels concurrents, une cle de ligne perimee au retour du second, et
     Shopify repond « Pas d identifiant ou de parametre de ligne valide ».

     La page panier est proprietaire quand elle est la — c est elle que la
     cliente regarde. Ce script ne s en charge que partout ailleurs. */
  /* Le script qui tient l ECRAN VISIBLE fait le travail, et lui seul.

     Sur petit ecran, arriver sur /cart ouvre le tiroir a la place de la page.
     cart-page.js ajoutait alors le cadeau et ne rafraichissait que le
     conteneur de la page, cache derriere le tiroir : la cliente regardait un
     tiroir rendu AVANT l ajout, ou le cadeau n apparaissait jamais. Il etait
     bien dans le panier, simplement invisible la ou elle regardait.

     Le tiroir reprend donc la main des que c est lui qu on voit. */
  var surPageCart = !!document.querySelector('[data-cart-page-inner]');
  var tiroirVisible = !surPageCart || window.matchMedia('(max-width: 899px)').matches;
  if (tiroirVisible) {
    purgeGift();
    addGift();
  }

  /* ---------- resynchronisation ------------------------------------------ */

  /* Le panier peut changer sans que ce script le sache.

     BundleX depose les taies offertes par un appel qui lui est propre, une
     a deux secondes APRES que le serveur a rendu la page. Mesure sur la
     boutique : /cart.js portait les quatre taies, et l ecran n affichait pas
     la carte cadeau. La cliente lisait un panier qui n existait plus.

     Le meme ecart tue le paiement. Shopify renvoie une caisse vide vers
     l accueil, sans un mot : panier vide par la corbeille, bouton de
     paiement encore affiche avec l ancien montant, et la cliente se retrouve
     sur la page d accueil sans comprendre. C est la deuxieme moitie du
     defaut signale sur iPhone, et c est la meme cause.

     On compare donc le compte affiche a celui du serveur, et on redessine
     quand ils different. Une comparaison, pas une horloge : rien ne tourne
     en fond, et un panier deja juste ne coute qu un appel a /cart.js. */
  function compteAffiche() {
    var n = $('[data-cart-inner]', panel);
    if (!n) return null;
    var v = parseInt(n.getAttribute('data-count'), 10);
    return isNaN(v) ? null : v;
  }

  function resynchroniser() {
    /* Pendant un echange de coloris le panier est a mi-chemin : le comparer
       a l ecran n a aucun sens, et redessiner ferait rejouer le garde-fou
       cadeau sur un panier incomplet. */
    if (verrouEchange(0) > 0) return Promise.resolve(null);
    return fetch('/cart.js', { headers: { 'Accept': 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c || compteAffiche() === c.item_count) return c;
        /* Sans en-tete Accept, et c est deliberé : avec `Accept: application/json`,
           Shopify repond le PANIER (token, items, totaux) et ignore ?sections=.
           La reponse etait donc toujours valide, jamais la bonne, et le silence
           etait total -- s[SECTION] valait undefined, on ne redessinait rien. */
        return fetch(window.location.pathname + '?sections=' + SECTION)
          .then(function (r) { return r.ok ? r.json() : null; })
          .then(function (s) { if (s && s[SECTION]) render(s[SECTION]); return c; });
      })
      .catch(function () { return null; });
  }

  /* Safari garde la page en cache quand on revient en arriere : elle
     reapparait telle qu on l avait laissee, panier compris. `persisted` ne
     vaut vrai que dans ce cas precis. */
  window.addEventListener('pageshow', function (e) { if (e.persisted) resynchroniser(); });

  /* Le tiroir et la page panier montrent le MEME panier.

     Sur /cart, le tiroir s ouvre par-dessus la page. Chaque script ne
     redessinait que sa propre surface : la corbeille du tiroir vidait le
     tiroir, et en le fermant la cliente retrouvait la page telle qu avant,
     avec les articles qu elle venait de retirer. Mesure sur la boutique,
     tiroir a zero article et page a quatre, en meme temps.

     On redessine donc l autre surface aussi, quand elle est la. Echange de
     noeud seulement : pas de garde-fou cadeau, pas de decompte relance. Ces
     decisions appartiennent au script qui possede la surface, et deux
     scripts qui les prendraient tous les deux se marcheraient dessus. */
  function rafraichirPage() {
    if (!document.querySelector('[data-cart-page-inner]')) return;
    /* Sans en-tete Accept, et c est deliberé : avec `Accept: application/json`,
       Shopify repond le PANIER (token, items, totaux) et ignore ?sections=.
       La reponse etait donc toujours valide, jamais la bonne, et le silence
       etait total -- s[SECTION] valait undefined, on ne redessinait rien. */
    return fetch(window.location.pathname + '?sections=main-cart')
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (s) {
        if (!s || !s['main-cart']) return;
        var doc = new DOMParser().parseFromString(s['main-cart'], 'text/html');
        var frais = doc.querySelector('[data-cart-page-inner]');
        var actuel = document.querySelector('[data-cart-page-inner]');
        if (frais && actuel) actuel.replaceWith(frais);
      })
      .catch(function () { /* l autre surface n est pas la vue courante */ });
  }

  /* Trois controles espaces, puis plus rien.

     L observateur ci-dessus ne voit que ce qui passe par fetch. Le cadeau de
     BundleX, lui, apparait SANS aucune requete observable depuis la page :
     mesure sur la boutique, /cart rendu a quatre articles, /cart.js a cinq,
     et pas un appel entre les deux. La mutation est faite ailleurs — cote
     serveur, ou par un transport qu on n instrumente pas. Aucun crochet
     client ne peut l apprendre : il faut aller demander.

     Trois demandes, a une seconde, deux et demie et quatre secondes et demie.
     Bornees, parce qu un panier qui n a pas bouge au bout de cinq secondes
     ne bougera plus, et qu une boucle sans fin coute a la cliente sa batterie
     et a nous notre quota. Chaque demande est un /cart.js ; le rendu de
     section n est demande que si les comptes different vraiment. */
  [900, 2200, 4500].forEach(function (d) { setTimeout(resynchroniser, d); });

  /* Redessiner quand QUELQU UN D AUTRE touche au panier.

     Un delai devine ne marche pas : j avais pose un second controle a
     1500 ms, et BundleX deposait son cadeau apres. Mesure sur la boutique,
     l ecran restait a quatre articles pendant que le panier en portait cinq.

     On ecoute donc l evenement lui-meme. Toute requete qui MODIFIE le panier
     — d ou qu elle vienne, application comprise — declenche une comparaison
     au tour suivant. Nos propres appels la declenchent aussi : ils ont deja
     redessine, la comparaison ne trouve rien et coute un /cart.js.

     fetch est enveloppe, jamais remplace : l appel d origine passe intact,
     et une erreur de notre cote ne doit pas emporter la requete. */
  if (window.fetch.__yk !== true) {
    var fetchOrigine = window.fetch;
    var enveloppe = function (u, o) {
      var p = fetchOrigine.apply(this, arguments);
      try {
        var url = typeof u === 'string' ? u : (u && u.url) || '';
        if (/\/cart\/(add|change|update|clear)(\.js)?(\?|$)/.test(url)) {
          p.then(function (r) { if (r && r.ok) setTimeout(resynchroniser, 0); })
           .catch(function () {});
        }
      } catch (e) { /* l enveloppe ne casse jamais la requete */ }
      return p;
    };
    enveloppe.__yk = true;
    window.fetch = enveloppe;
  }

  /* Aucun panier vide n atteint la caisse.

     form.submit() n emporte pas le nom du bouton qui a declenche l envoi :
     sans ce champ cache, le formulaire posterait sur /cart sans `checkout`
     et ne partirait jamais au paiement. */
  panel.addEventListener('submit', function (e) {
    var f = e.target && e.target.closest ? e.target.closest('[data-cart-checkout]') : null;
    if (!f || f.getAttribute('data-verifie') === '1') return;
    e.preventDefault();
    function partir() {
      f.setAttribute('data-verifie', '1');
      var h = document.createElement('input');
      h.type = 'hidden'; h.name = 'checkout'; h.value = '';
      f.appendChild(h);
      f.submit();
    }
    resynchroniser().then(function (c) {
      /* Serveur injoignable : on laisse partir plutot que de bloquer une
         vente sur une incertitude. */
      if (!c) { partir(); return; }
      if (c.item_count === 0) { showError('Votre panier est vide.'); resynchroniser(); return; }
      partir();
    });
  });
})();
